import EmployeeQueueTaskAccessEnum from '../../../../../../projects/performers/enums/EmployeeQueueTaskAccessEnum';

/**
 * * Модель ответа на получение доступов у текущего пользователя в очереди задач по идентификатору
 */
export default class GetAccessCurrentUserInQueueTaskByIdResponse  {
	/**
	 * * Todo старое поле - убрать когда от него избавится клиент
            Является ли текущий пользователь овнером/админом проекта/рабочей области
	 */
	IsAdmin: boolean = false;
	/**
	 * * Админ проекта
	 */
	IsProjectAdmin: boolean = false;
	/**
	 * * Админ рабочей области
	 */
	IsNamespaceAdmin: boolean = false;
	/**
	 * * Является овнером
	 */
	IsOwner: boolean = false;
	/**
	 * * Имеет доступ к очереди
	 */
	HasQueueTaskAccess: boolean = false;
	/**
	 * * Возможность формир
	 */
	CanCustomizeOrder: boolean = false;
	/**
	 * * Список доступов в очереди задач у текущего пользователя
	 */
	EmployeeQueueTaskAccesses!: Array<EmployeeQueueTaskAccessEnum>;
	constructor(obj?: Partial<GetAccessCurrentUserInQueueTaskByIdResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
